 document.addEventListener('DOMContentLoaded', function () {

// Global variables
let swiperInstance = null;
const swiperContainer = document.querySelector('.product-media-display');
if (!swiperContainer) return;

// Initialize based on screen size
function initGallery() {
  const isMobile = window.innerWidth < 950;
  
  if (isMobile) {
    // Mobile: Initialize Swiper
    if (!swiperInstance) {
      initMobileSwiper();
    }
  } else {
    // Desktop: Destroy Swiper if exists, use CSS Grid
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
    initDesktopGrid();
  }
}

// Mobile Swiper initialization
function initMobileSwiper() {
  // Add swiper class for mobile (prevents auto-init on desktop)
  swiperContainer.classList.add('swiper');
  
  // Get slide count from Liquid (server-side, no DOM query needed)
  const slideCount = parseInt(swiperContainer.dataset.slideCount || '0');
  
  // Only enable loop if there are 2+ slides (Swiper requirement)
  const enableLoop = slideCount >= 2;
  
  swiperInstance = new Swiper('.product-media-display', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: enableLoop,
    loopAdditionalSlides: enableLoop ? 1 : 0,
    zoom: {
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: true,
    },
  });
}

// Desktop Grid initialization  
function initDesktopGrid() {
  // Remove ALL Swiper classes (prevents Swiper from initializing)
  swiperContainer.classList.remove('swiper', 'swiper-initialized', 'swiper-horizontal');
  const wrapper = swiperContainer.querySelector('.swiper-wrapper');
  if (wrapper) {
    wrapper.style.transform = 'none';
  }

  // Desktop zoom and drag functionality
  setupDesktopZoomAndDrag();
}

// Desktop zoom and drag setup
function setupDesktopZoomAndDrag() {
  let isDragging = false;
  let draggedSlide = null;
  let startX = 0;
  let startY = 0;
  let translateX = 0;
  let translateY = 0;
  
  // Function to zoom in an image (progressive: 1x → 2x → 3x)
  function zoomIn(slide) {
    if (!slide) return;
    
    const zoomContainer = slide.querySelector('.swiper-zoom-container');
    if (!zoomContainer) return;
    
    // Get current zoom level (default is 1)
    const currentZoom = parseFloat(slide.dataset.zoomLevel || '1');
    
    // Calculate next zoom level
    let nextZoom;
    if (currentZoom === 1) {
      nextZoom = 2;
    } else if (currentZoom === 2) {
      nextZoom = 3;
    } else {
      nextZoom = 3; // Already at max
    }
    
    // First, reset any other zoomed slides
    const allSlides = swiperContainer.querySelectorAll('.swiper-slide-zoomed');
    allSlides.forEach(zoomedSlide => {
      if (zoomedSlide !== slide) {
        const zoomedContainer = zoomedSlide.querySelector('.swiper-zoom-container');
        const zoomOutBtn = zoomedSlide.querySelector('.gallery-zoom-out');
        const zoomInBtn = zoomedSlide.querySelector('.gallery-zoom-in');
        if (zoomedContainer) {
          zoomedContainer.style.transition = 'transform 300ms ease';
          zoomedContainer.style.transform = 'translate3d(0px, 0px, 0px) scale(1)';
          zoomedSlide.classList.remove('swiper-slide-zoomed');
          zoomedSlide.dataset.translateX = '0';
          zoomedSlide.dataset.translateY = '0';
          zoomedSlide.dataset.zoomLevel = '1';
          
          // Reset button states
          if (zoomOutBtn) {
            zoomOutBtn.style.opacity = '0.3';
            zoomOutBtn.style.pointerEvents = 'none';
          }
          if (zoomInBtn) {
            zoomInBtn.style.opacity = '1';
            zoomInBtn.style.pointerEvents = 'auto';
          }
        }
      }
    });
    
    // Get current translate values to maintain pan position
    const currentTranslateX = parseFloat(slide.dataset.translateX || '0');
    const currentTranslateY = parseFloat(slide.dataset.translateY || '0');
    
    // Scale the translate values proportionally to the new zoom level
    const zoomRatio = nextZoom / currentZoom;
    let newTranslateX = currentTranslateX * zoomRatio;
    let newTranslateY = currentTranslateY * zoomRatio;
    
    // Calculate max allowed translate for new zoom level to prevent blank areas
    const containerRect = slide.getBoundingClientRect();
    const maxTranslateX = ((nextZoom - 1) * containerRect.width) / 2;
    const maxTranslateY = ((nextZoom - 1) * containerRect.height) / 2;
    
    // Constrain translate values to valid limits
    newTranslateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, newTranslateX));
    newTranslateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, newTranslateY));
    
    // Apply the zoom with maintained pan position
    slide.dataset.translateX = newTranslateX;
    slide.dataset.translateY = newTranslateY;
    slide.dataset.zoomLevel = nextZoom;
    
    zoomContainer.style.transition = 'transform 300ms ease';
    zoomContainer.style.transform = `translate3d(${newTranslateX}px, ${newTranslateY}px, 0px) scale(${nextZoom})`;
    slide.classList.add('swiper-slide-zoomed');
    
    // Update button states
    const zoomOutBtn = slide.querySelector('.gallery-zoom-out');
    const zoomInBtn = slide.querySelector('.gallery-zoom-in');
    
    // Zoom out button always active when zoomed
    if (zoomOutBtn) {
      zoomOutBtn.style.opacity = '1';
      zoomOutBtn.style.pointerEvents = 'auto';
    }
    
    // Zoom in button: active if not at max (3x), faded if at max
    if (zoomInBtn) {
      if (nextZoom === 3) {
        zoomInBtn.style.opacity = '0.3';
        zoomInBtn.style.pointerEvents = 'none';
      } else {
        zoomInBtn.style.opacity = '1';
        zoomInBtn.style.pointerEvents = 'auto';
      }
    }
    
    setTimeout(() => {
      zoomContainer.style.transition = '';
    }, 300);
  }
  
  // Zoom in button click handler
  swiperContainer.addEventListener('click', function(e) {
    if (e.target.closest('.gallery-zoom-in')) {
      e.stopPropagation();
      
      if (window.innerWidth < 950) return;
      
      const slide = e.target.closest('.swiper-slide');
      if (!slide) return;
      
      zoomIn(slide);
    }
  });
  
  // Zoom out button click handler (progressive: 3x → 2x → 1x)
  swiperContainer.addEventListener('click', function(e) {
    if (e.target.closest('.gallery-zoom-out')) {
      e.stopPropagation();
      
      const slide = e.target.closest('.swiper-slide');
      if (!slide) return;
      
      const zoomContainer = slide.querySelector('.swiper-zoom-container');
      const zoomOutBtn = slide.querySelector('.gallery-zoom-out');
      const zoomInBtn = slide.querySelector('.gallery-zoom-in');
      
      if (zoomContainer) {
        // Get current zoom level
        const currentZoom = parseFloat(slide.dataset.zoomLevel || '1');
        
        // Calculate next zoom level
        let nextZoom;
        if (currentZoom === 3) {
          nextZoom = 2;
        } else if (currentZoom === 2) {
          nextZoom = 1;
        } else {
          nextZoom = 1; // Already at min
        }
        
        // Get current translate values to maintain pan position
        const currentTranslateX = parseFloat(slide.dataset.translateX || '0');
        const currentTranslateY = parseFloat(slide.dataset.translateY || '0');
        
        // Scale the translate values proportionally to the new zoom level
        const zoomRatio = nextZoom / currentZoom;
        let newTranslateX = currentTranslateX * zoomRatio;
        let newTranslateY = currentTranslateY * zoomRatio;
        
        // Calculate max allowed translate for new zoom level to prevent blank areas
        const containerRect = slide.getBoundingClientRect();
        const maxTranslateX = ((nextZoom - 1) * containerRect.width) / 2;
        const maxTranslateY = ((nextZoom - 1) * containerRect.height) / 2;
        
        // Constrain translate values to valid limits
        newTranslateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, newTranslateX));
        newTranslateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, newTranslateY));
        
        // Apply zoom out with maintained pan position
        slide.dataset.translateX = newTranslateX;
        slide.dataset.translateY = newTranslateY;
        slide.dataset.zoomLevel = nextZoom;
        
        zoomContainer.style.transition = 'transform 300ms ease';
        zoomContainer.style.transform = `translate3d(${newTranslateX}px, ${newTranslateY}px, 0px) scale(${nextZoom})`;
        
        // Update class and button states
        if (nextZoom === 1) {
          slide.classList.remove('swiper-slide-zoomed');
          
          // At 1x: zoom-out disabled, zoom-in enabled
          if (zoomOutBtn) {
            zoomOutBtn.style.opacity = '0.3';
            zoomOutBtn.style.pointerEvents = 'none';
          }
          if (zoomInBtn) {
            zoomInBtn.style.opacity = '1';
            zoomInBtn.style.pointerEvents = 'auto';
          }
        } else {
          slide.classList.add('swiper-slide-zoomed');
          
          // At 2x: both buttons enabled
          if (zoomOutBtn) {
            zoomOutBtn.style.opacity = '1';
            zoomOutBtn.style.pointerEvents = 'auto';
          }
          if (zoomInBtn) {
            zoomInBtn.style.opacity = '1';
            zoomInBtn.style.pointerEvents = 'auto';
          }
        }
        
        setTimeout(() => {
          zoomContainer.style.transition = '';
        }, 300);
      }
    }
  });
  
  // Drag functionality for zoomed images
  const handleMouseDown = function(e) {
    if (window.innerWidth < 950) return;
    
    // Don't start drag if clicking on buttons
    if (e.target.closest('.gallery-controls-container') || e.target.closest('button')) {
      return;
    }
    
    const slide = e.target.closest('.swiper-slide');
    if (!slide || !slide.classList.contains('swiper-slide-zoomed')) return;
    
    const zoomContainer = slide.querySelector('.swiper-zoom-container');
    if (!zoomContainer) return;
    
    isDragging = true;
    draggedSlide = slide;
    
    // Get current translate values from dataset
    translateX = parseFloat(slide.dataset.translateX || '0');
    translateY = parseFloat(slide.dataset.translateY || '0');
    
    startX = e.clientX - translateX;
    startY = e.clientY - translateY;
    
    zoomContainer.style.cursor = 'grabbing';
    document.body.style.userSelect = 'none';
    
    e.preventDefault();
    e.stopPropagation();
  };
  
  const handleMouseMove = function(e) {
    if (!isDragging || !draggedSlide) return;
    
    const zoomContainer = draggedSlide.querySelector('.swiper-zoom-container');
    if (!zoomContainer) return;
    
    const currentX = e.clientX - startX;
    const currentY = e.clientY - startY;
    
    // Get current zoom level from dataset
    const zoomLevel = parseFloat(draggedSlide.dataset.zoomLevel || '1');
    const containerRect = draggedSlide.getBoundingClientRect();
    
    // Calculate how much we can pan in each direction
    // Formula: (zoom - 1) * dimension / 2
    const maxTranslateX = ((zoomLevel - 1) * containerRect.width) / 2;
    const maxTranslateY = ((zoomLevel - 1) * containerRect.height) / 2;
    
    translateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, currentX));
    translateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, currentY));
    
    // Store translate values in dataset
    draggedSlide.dataset.translateX = translateX;
    draggedSlide.dataset.translateY = translateY;
    
    // Use current zoom level in transform
    zoomContainer.style.transform = `translate3d(${translateX}px, ${translateY}px, 0px) scale(${zoomLevel})`;
    e.preventDefault();
  };
  
  const handleMouseUp = function(e) {
    if (isDragging && draggedSlide) {
      const zoomContainer = draggedSlide.querySelector('.swiper-zoom-container');
      if (zoomContainer) {
        zoomContainer.style.cursor = 'grab';
      }
      
      document.body.style.userSelect = '';
      isDragging = false;
      draggedSlide = null;
    }
  };
  
  // Attach drag event listeners with passive where possible
  swiperContainer.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('mousemove', handleMouseMove, { passive: false }); // Can't be passive (calls preventDefault)
  document.addEventListener('mouseup', handleMouseUp, { passive: true });
}

// Initialize gallery
initGallery();

// Handle window resize with debounce - only reinit on breakpoint cross
let resizeTimeout;
let lastWidth = window.innerWidth;

window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function() {
    const currentWidth = window.innerWidth;
    const wasDesktop = lastWidth >= 950;
    const isDesktop = currentWidth >= 950;
    
    // Only re-init if crossed mobile/desktop breakpoint
    if (wasDesktop !== isDesktop) {
      initGallery();
      lastWidth = currentWidth;
    }
  }, 150); // Reduced from 250ms for faster response
}, { passive: true });

// Cylindo 360 view handlers - with null checks
const threeViewButton = document.querySelector('.three-view');
const closeCylindoButton = document.querySelector('.close-button-cylindo');
const imageGallery = document.querySelector('.image-gallery');

if (threeViewButton && imageGallery) {
  threeViewButton.addEventListener('click', function () {
    imageGallery.classList.add('open-cylindo');
  });
}

if (closeCylindoButton && imageGallery) {
  closeCylindoButton.addEventListener('click', function() {
    imageGallery.classList.remove('open-cylindo');
  });
}


document.addEventListener('click', function (e) {
  if (e.target.closest('.gallery-full-screen')) {
    e.stopPropagation();
    document.querySelector('body')?.classList.add('open-fullscreen');
    document.body.style.overflow = 'hidden';
    document.querySelector('.gallery-close-full-screen')?.classList.remove('hidden');
  }
});

document.addEventListener('click', function (e) {
   if (e.target.closest('.gallery-close-full-screen')) {
    document.querySelector('body')?.classList.remove('open-fullscreen');
      document.querySelector('.gallery-close-full-screen')?.classList.add('hidden');
      document.body.style.overflow = '';
   }
});

// View More button functionality (Desktop only)
const viewMoreBtn = document.querySelector('.gallery-view-more-btn');
if (viewMoreBtn) {
  viewMoreBtn.addEventListener('click', function() {
    const hiddenItems = document.querySelectorAll('.gallery-hidden-item');
    const isExpanded = this.classList.contains('expanded');
    
    if (isExpanded) {
      // Collapse: Hide items beyond 6th
      hiddenItems.forEach(item => {
        item.style.display = 'none';
      });
      this.classList.remove('expanded');
      
      // Update button text
      const remainingCount = hiddenItems.length;
      this.querySelector('.view-more-text').textContent = `View More`;
      
      // Scroll to the "View More" button position
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      // Expand: Show all hidden items and load images
      hiddenItems.forEach(item => {
        // Load lazy images (only on desktop, not mobile/tablet)
        if (window.innerWidth >= 950) {
          const lazyImages = item.querySelectorAll('.lazy-load-desktop[data-desktop-src]');
          lazyImages.forEach(img => {
            if (img.dataset.desktopSrc) {
              // Swap placeholder with real image
              img.src = img.dataset.desktopSrc;
              img.removeAttribute('data-desktop-src');
              img.classList.add('loaded');
              img.classList.remove('lazy-load-desktop');
              
              // Add loading attribute for browser optimization
              img.loading = 'lazy';
            }
          });
        }
        
        item.style.display = 'block';
      });
      this.classList.add('expanded');
      
      // Update button text
      this.querySelector('.view-more-text').textContent = 'Show Less';
    }
  });
}


  });